<section [formGroup]="stepForm">
  <mbs-form-group>
    <mbs-radio formControlName="type"
               name="RestoreDiskType"
               [label]="'wizards:restoreDisks.restoreAll' | i18next"
               (change)="virtualDiskRestoreTypeChangeHandler(virtualDisksSelectedType.All)"
               [value]="virtualDisksSelectedType.All"
               [id]="'type-restore-disks-radio-1'"></mbs-radio>
    <mbs-radio formControlName="type"
               name="RestoreDiskType"
               [label]="'wizards:restoreDisks.restoreSelected' | i18next"
               (change)="virtualDiskRestoreTypeChangeHandler(virtualDisksSelectedType.Selected)"
               [value]="virtualDisksSelectedType.Selected"
               [id]="'type-restore-disks-radio-2'"></mbs-radio>
  </mbs-form-group>

  <mbs-form-group class="restore-disks-tree position-relative">
    <mbs-card *ngIf="!isRDMode"
              [size]="MbsSize.sm"
              [staticHeight]="380">
      <mbs-loader *ngIf="loadingTree"
                  size="small"></mbs-loader>

      <mbs-alert *ngIf="!treeData.length"
                 class="mb-0 mt-2"
                 [type]="mbsPopupType.warning"
                 [icon]="true">
        {{ 'wizards:no_data_to_restore' | i18next }}
      </mbs-alert>

      <mbs-tree *ngIf="treeData.length"
                (mbsChange)="changeTreeHandler($event)"
                [customDisableText]="'wizards:restoreDisks.selectDiskTooltip' | i18next"
                [disabledTree]="disabledTree"
                [childrenManualControl]="true"
                [disableIfLoadingSubtree]="true"
                [data]="treeData"
                [disableChildren]="false"
                [dontSelectChildren]="false"
                [getItems]="getSubtree.bind(this)"
                [loadMore]="getSubtree.bind(this)"
                [itemsCanBeHidden]="true"
                [lazy]="true"
                [offCheckAndIndeterminate]="true"
                classesForRoot="restore-disks-tree"
                mode="file">
        <ng-template treeElement
                     let-item>
          <div class="d-flex align-items-center">
            <img class="restore-disks-tree_img-version mr-2"
                 [src]="item.icon">
            {{ item.label }}
          </div>
        </ng-template>
      </mbs-tree>
    </mbs-card>
  </mbs-form-group>
</section>
